// ChartJSPieChart.js
import React from 'react'
import { Pie } from 'react-chartjs-2'
import 'chart.js/auto'

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28CF4', '#FF6666']

const ChartJSPieChart = ({ data }) => {
  const chartData = {
    labels: data.map(item => item.carrierName),
    datasets: [
      {
        data: data.map(item => item.shipmentPercentage),
        backgroundColor: data.map((_, idx) => COLORS[idx % COLORS.length]),
        borderWidth: 1,
        borderColor: '#fff',
        hoverOffset: 8,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          color: '#374151',
          font: { size: 14 }
        }
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: ${ctx.raw}%`
        }
      }
    }
  }

  return <Pie data={chartData} options={options} />
}

export default ChartJSPieChart
